import {
	CalculatorIcon,
	CommunityIcon,
	GraduationIcon,
	HomeIcon,
	MarkerIcon,
	ProfileIcon,
	RocketOutline,
	SparkleIcon,
	TenantFinderIcon,
	ThiefIcon,
	Toolbox,
	VaultIcon,
} from '../assets';
import { Claim } from '../types';
import { SUPER_USER_ID } from './global.constants';
import TomAvatar from '../assets/images/tom_sidebar.webp';

export const userMenuItems = [
	{
		id: Claim['My Profile'],
		text: 'My S8 Profile',
		icon: ProfileIcon,
		link: '/my-profile',
		accordion: true,
	},
];

/** Items that open for any of several claims list them in `accessClaims`; the rest use `id`. */
export const hasNavItemClaim = (
	item: { id: number; accessClaims?: readonly number[] },
	claimsIds: number[],
) =>
	item.accessClaims
		? item.accessClaims.some(claim => claimsIds.includes(claim))
		: claimsIds.includes(item.id);

export const LinkItems = [
	{
		id: -1,
		text: 'Quick Start',
		icon: RocketOutline,
		link: '/quick-start',
		accordion: false,
		guestRestricted: true,
	},
	{
		id: Claim['Deal Explorer'],
		text: 'Deal Explorer',
		icon: HomeIcon,
		link: '/deal-explorer',
		accordion: true,
	},
	{
		id: Claim['FMR Explorer'],
		text: 'FMR Explorer',
		icon: MarkerIcon,
		link: '/fmr-explorer',
		accordion: true,
	},
	{
		id: Claim.AiAnalyze,
		text: 'Tom AI',
		icon: SparkleIcon,
		link: '/ai-assistant',
		accordion: false,
		adminOnly: true,
	},
	{
		id: Claim.Courses,
		text: 'Real Estate Courses',
		icon: GraduationIcon,
		link: '/courses',
		accordion: false,
	},
	{
		id: Claim.Vault,
		text: 'LLC Vault',
		icon: VaultIcon,
		link: '/llc-vault',
		accordion: false,
	},
	{
		id: Claim['Property Lookup'],
		text: 'Crime Lookup',
		icon: ThiefIcon,
		link: '/crime-lookup',
		accordion: true,
		accessClaims: [Claim['Property Lookup'], Claim['Deal Explorer']],
	},
	{
		id: Claim['Deal Calculator'],
		text: 'Deal Calculator',
		icon: CalculatorIcon,
		link: '/deal-calculator',
		accordion: true,
	},
	{
		id: Claim.Vendors,
		text: 'Vendors',
		icon: Toolbox,
		link: '/vendors',
		accordion: true,
	},
	{
		id: Claim.Messenger,
		text: 'Community',
		icon: CommunityIcon,
		link: '/messenger/community/1',
		accordion: false,
		// disabledBadgeText: 'Coming soon',
		optionalClassName: 'guide-community',
	},

	{
		id: Claim.Coaching,
		text: '1 on 1 with Tom',
		avatar: TomAvatar,
		link: `/messenger/direct/${SUPER_USER_ID}`,
		accordion: false,
		// disabledBadgeText: 'Coming soon',
		optionalClassName: 'guide-coaching',
	},
	{
		id: Claim.TenantFinder,
		text: 'Tenant Finder',
		icon: TenantFinderIcon,
		link: '/tenant-finder',
		accordion: false,
		disabledBadgeText: 'Coming soon',
	},
	// {
	// 	// id: Claim['FMR Explorer'],
	// 	id: 1,
	// 	text: 'CruzCTRL',
	// 	icon: PropertyManagement,
	// 	link: '',
	// 	accordion: false,
	// 	disabledBadgeText: '',
	// },
];
